//#region src/nodey-graph-templates/camera-snapshot.ts
var e = (e) => ({
	options: {},
	connections: [
		{
			inputName: "image_data",
			inputNodeId: "d16c9d0c-4dd7-4889-a760-9eb3ad8fe0de",
			isEnabled: !0,
			outputName: "image_data",
			outputNodeId: "d110a7bf-09ef-4afa-a9e6-af29c8c2dd63",
			type: "image"
		},
		{
			inputName: "width",
			inputNodeId: "d16c9d0c-4dd7-4889-a760-9eb3ad8fe0de",
			isEnabled: !0,
			outputName: "value",
			outputNodeId: "aad5b6b4-8f11-46af-8839-45c71c4c8851",
			type: "integer"
		},
		{
			inputName: "height",
			inputNodeId: "d16c9d0c-4dd7-4889-a760-9eb3ad8fe0de",
			isEnabled: !0,
			outputName: "value",
			outputNodeId: "c2525fa2-e55d-423d-b89e-d0ebc6fd3e6e",
			type: "integer"
		},
		{
			inputName: "image_data",
			inputNodeId: "0708230b-31f3-46a5-aa29-77a4ba426a6f",
			isEnabled: !0,
			outputName: "resized_image",
			outputNodeId: "d16c9d0c-4dd7-4889-a760-9eb3ad8fe0de",
			type: "image"
		}
	],
	frames: [],
	nodes: {
		"d110a7bf-09ef-4afa-a9e6-af29c8c2dd63": {
			collapsed: !1,
			customName: "Cinematic Camera",
			id: "d110a7bf-09ef-4afa-a9e6-af29c8c2dd63",
			isEnabled: !0,
			position: {
				x: 90.88507847982818,
				y: 246.3479236824072
			},
			provenance: {
				created_at: "2026-08-04T11:05:05.769Z",
				creator_id: "6644d3b4600fc7bfaac7d95d",
				last_editor_id: "6644d3b4600fc7bfaac7d95d",
				updated_at: "2026-08-04T11:07:32.501Z"
			},
			type: "cinematic-camera",
			io: {
				inputs: e.cinematicCameraComponent ? { camera_id: {
					defined: !0,
					source: { kind: "local" },
					value: e.cinematicCameraComponent.getUniqueId()
				} } : {},
				outputs: {}
			}
		},
		"0708230b-31f3-46a5-aa29-77a4ba426a6f": {
			collapsed: !1,
			customName: "Save OKO Image Asset",
			id: "0708230b-31f3-46a5-aa29-77a4ba426a6f",
			io: {
				inputs: { asset_upload: {
					defined: !0,
					source: { kind: "local" },
					value: { name: `${e.cinematicCameraComponent?.name}-snapshot` }
				} },
				outputs: {}
			},
			isEnabled: e.options?.saveAsset ?? !1,
			position: {
				x: 755.180963702238,
				y: 302.54762660173475
			},
			provenance: {
				created_at: "2026-08-04T11:05:05.769Z",
				creator_id: "6644d3b4600fc7bfaac7d95d",
				last_editor_id: "6644d3b4600fc7bfaac7d95d",
				updated_at: "2026-08-04T11:07:32.501Z"
			},
			type: "io-image-asset-save"
		},
		"d16c9d0c-4dd7-4889-a760-9eb3ad8fe0de": {
			collapsed: !1,
			customName: "Image Resize",
			id: "d16c9d0c-4dd7-4889-a760-9eb3ad8fe0de",
			io: {
				inputs: {},
				outputs: {}
			},
			isEnabled: !0,
			position: {
				x: 427.3010017949544,
				y: 315.03773203296714
			},
			provenance: {
				created_at: "2026-08-04T11:05:45.094Z",
				creator_id: "6644d3b4600fc7bfaac7d95d",
				last_editor_id: "6644d3b4600fc7bfaac7d95d",
				updated_at: "2026-08-04T11:07:32.501Z"
			},
			type: "image-resize"
		},
		"aad5b6b4-8f11-46af-8839-45c71c4c8851": {
			collapsed: !1,
			customName: "Integer",
			id: "aad5b6b4-8f11-46af-8839-45c71c4c8851",
			io: {
				inputs: { value: {
					defined: !0,
					source: { kind: "local" },
					value: e.options?.width
				} },
				outputs: {}
			},
			isEnabled: !0,
			position: {
				x: 90.41870869549959,
				y: 573.6678389400288
			},
			provenance: {
				created_at: "2026-08-04T11:06:08.622Z",
				creator_id: "6644d3b4600fc7bfaac7d95d",
				last_editor_id: "6644d3b4600fc7bfaac7d95d",
				updated_at: "2026-08-04T11:07:32.501Z"
			},
			type: "const-integer"
		},
		"c2525fa2-e55d-423d-b89e-d0ebc6fd3e6e": {
			collapsed: !1,
			customName: "Integer",
			id: "c2525fa2-e55d-423d-b89e-d0ebc6fd3e6e",
			io: {
				inputs: { value: {
					defined: !0,
					source: { kind: "local" },
					value: e.options?.height
				} },
				outputs: {}
			},
			isEnabled: !0,
			position: {
				x: 90.41870869549959,
				y: 742.1089854897563
			},
			provenance: {
				created_at: "2026-08-04T11:06:16.597Z",
				creator_id: "6644d3b4600fc7bfaac7d95d",
				last_editor_id: "6644d3b4600fc7bfaac7d95d",
				updated_at: "2026-08-04T11:07:32.501Z"
			},
			type: "const-integer"
		}
	}
});
//#endregion
export { e as cameraSnapshotTemplate };
